export interface HeaderOptions {
    container: HTMLDivElement;
    title?: string;
    subtitle?: string;
    visible?: boolean;
    collapsed?: boolean;
}

export class Header {

    private _element: HTMLDivElement;
    private _options: HeaderOptions;
    private _title: HTMLElement;
    private _subtitle: HTMLElement;
    private _textContainer:HTMLElement;

    constructor(options: HeaderOptions) {

        options = e5.object.merge({
            container: null,
            title: "",
            subtitle: "",
            visible: true,
            collapsed: false
        } as HeaderOptions, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "header";
        this._element.innerHTML = `
        <div class="header__text-container base--hide-top">
            <h1 class="header__title"></h1>
            <h2 class="header__subtitle"></h2>
        </div>
        <div class="header__logo">
            <div class="header__logo-image e5 icon-580" ></div>            
        </div>
        `;
        this._title = this._element.querySelector(".header__title");
        this._subtitle = this._element.querySelector(".header__subtitle");
        this._textContainer = this._element.querySelector(".header__text-container");

        if (options.title) {
            this.title = options.title;
        }

        if (options.subtitle) {
            this.subtitle = options.subtitle;
        }

        if (!options.visible) {
            this.visible = false;
        }

        if (options.collapsed) {
            this.collapsed = true;
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public get title(): string {
        return this._title.textContent;
    }

    public set title(value: string) {
        this._title.textContent = value;
    }

    public get subtitle(): string {
        return this._subtitle.textContent;
    }

    public set subtitle(value: string) {
        this._subtitle.textContent = value;
    }

    public get visible(): boolean {
        return !this._element.classList.contains("header--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("header--hidden", !value);
    }

    public get collapsed(): boolean {
        return this._textContainer.classList.contains("base--hidden");
    }

    public set collapsed(value: boolean) {
        this._textContainer.classList.toggle("base--hidden", value);
    }
}